import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {ContractLinkSummaries} from '../models/contract-link';
import {LoadSubscriptionsLinkContractSuccessAction, subscriptionsLinkContractActionTypes} from '../actions/subscription-link-contract';


export interface SubscriptionsLinkContractState {
  array: ContractLinkSummaries[];
}

const initialState: SubscriptionsLinkContractState = {
  array: []
};

export function subscriptionsLinkContractReducer(state: SubscriptionsLinkContractState = initialState, action: Action): SubscriptionsLinkContractState {
  switch (action.type) {
    case subscriptionsLinkContractActionTypes.LOAD:
      return handleLoadAction();
    case subscriptionsLinkContractActionTypes.LOAD_SUCCESS:
      return handleLoadSuccess(state, action);
    case subscriptionsLinkContractActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadAction(): SubscriptionsLinkContractState {
  return initialState;
}

function handleLoadSuccess(state: SubscriptionsLinkContractState, action: LoadSubscriptionsLinkContractSuccessAction): SubscriptionsLinkContractState {
  const newState = _.clone(state);
  const payload = _.clone(action.payload);
  // tslint:disable-next-line:no-any
  const subscriptionListArray: any[] = [];
  if (payload.length > 0) {
    // tslint:disable-next-line:no-any
    payload.forEach( function ( item: any, i: number): void {

      if ( item.playerName ) {
        subscriptionListArray.push(Object.assign({},
          {subscriptionName: item.name + ' (' + item.playerName + ')'}, {subscriptionUuid: item.uuid} , {isBillingLinked: item.isBillingLinked}))

      } else {
        subscriptionListArray.push(Object.assign({},
          {subscriptionName: item.name}, {subscriptionUuid: item.uuid}, {isBillingLinked: item.isBillingLinked}))
      }
    });
  }
  newState.array = subscriptionListArray || [];
  return newState;
}

function handleLoadFailAction(state: SubscriptionsLinkContractState): SubscriptionsLinkContractState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}

export const subscriptionsLinkContractSelectors = {
  array: (state: SubscriptionsLinkContractState) => _.get(state, 'array', [])
};
